var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bottom-navigation", class: { hidden: _vm.isHidden } },
    [
      _c(
        "v-bottom-nav",
        {
          class: {
            "ios-height":
              _vm.userAgent === "ios" && _vm.iosAppVersion === "fromWeb"
          },
          attrs: {
            id: "qa-bottom-navigation",
            app: "",
            fixed: "",
            value: true,
            height: "60"
          }
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.brandTemplate === "generic_2" &&
                    _vm.selectionsNo &&
                    _vm.betslipMobileIsVisible &&
                    _vm.navgroupcontext4menu !== "pm",
                  expression:
                    "brandTemplate === 'generic_2' && selectionsNo && betslipMobileIsVisible && navgroupcontext4menu !== 'pm'"
                }
              ],
              staticClass: "betslip_mobile_msg",
              on: {
                click: function($event) {
                  return _vm.toggleBetslip()
                }
              }
            },
            [
              _c("span", { staticClass: "feedback-label" }, [
                _c("span", { staticClass: "badge" }, [
                  _vm._v(_vm._s(_vm.selectionsNo))
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "betslip-label" }, [
                  _vm._v(
                    _vm._s(
                      _vm.selectionsNo > 1
                        ? _vm.$t("BottomNav.Betslip.Selections")
                        : _vm.$t("BottomNav.Betslip.Selection")
                    )
                  )
                ])
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "betslip_up_icon" }),
              _vm._v(" "),
              _c("span", { staticClass: "feedback-msg" }, [
                _c("div", [_vm._v(_vm._s(_vm.feedback))])
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    !_vm.isReadOnly &&
                    _vm.brandTemplate === "generic_2" &&
                    _vm.pmSelectedRunnersCount &&
                    _vm.betslipMobileIsVisible &&
                    _vm.navgroupcontext4menu === "pm",
                  expression:
                    "!isReadOnly && brandTemplate === 'generic_2' && pmSelectedRunnersCount && betslipMobileIsVisible && navgroupcontext4menu === 'pm'"
                }
              ],
              staticClass: "betslip_mobile_msg",
              on: {
                click: function($event) {
                  return _vm.togglePmBetslip()
                }
              }
            },
            [
              _c("span", { staticClass: "feedback-label" }, [
                _c("span", { staticClass: "badge" }, [
                  _vm._v(_vm._s(_vm.pmSelectedRunnersCount))
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "betslip-label" }, [
                  _vm._v(
                    _vm._s(
                      _vm.pmSelectedRunnersCount > 1
                        ? _vm.$t("Betslip.PM.Runners")
                        : _vm.$t("Betslip.PM.Runner")
                    )
                  )
                ])
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "betslip_up_icon" })
            ]
          ),
          _vm._v(" "),
          _vm.routerNavGroups &&
          _vm.routerNavGroups.navset === "mixed" &&
          _vm.hasActiveNavGroups(["pm"]) &&
          _vm.navgroupcontext4menu === "pm"
            ? [
                _c(
                  "v-btn",
                  {
                    staticClass: "sports menu",
                    class: [
                      { "home promotions-v2": _vm.brandLayout === "generic" },
                      { active: _vm.activeHomePM }
                    ],
                    attrs: {
                      id: "qa-sports-home",
                      ripple: false,
                      flat: "",
                      color: "teal",
                      value: "recent"
                    },
                    on: {
                      click: function() {
                        _vm.togglePmBetslipOff()
                        _vm.go2PmBetting()
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "btn-icon-container" },
                      [_c("icon", { attrs: { name: "icon-home" } })],
                      1
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "bottom_nav_text" }, [
                      _vm._v(_vm._s(_vm.$t("BottomNav.RacingHome")))
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    staticClass: "sports menu",
                    class: [
                      { active: _vm.dialogSportsMenu || _vm.isSportsActive },
                      { btnHR: _vm.brandLayout === "generic" }
                    ],
                    attrs: {
                      id: "qa-sports-horseracing",
                      ripple: false,
                      flat: "",
                      color: "teal",
                      value: "recent"
                    },
                    on: {
                      click: function() {
                        _vm.togglePmBetslipOff()
                        _vm.toggleMenu()
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "btn-icon-container" }, [
                      _c("span", { staticClass: "icon-horseracing" })
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "bottom_nav_text",
                        class: _vm.dialogSportsMenu ? "blue" : ""
                      },
                      [_vm._v(_vm._s(_vm.$t("BottomNav.AllRacing")))]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "router-link",
                  { staticClass: "v-btn", attrs: { to: _vm.homeHandler() } },
                  [
                    _c(
                      "v-btn",
                      {
                        staticClass: "home promotions-v2",
                        class: [
                          { active: _vm.activeHome },
                          { "sports home": _vm.brandLayout === "generic" }
                        ],
                        attrs: {
                          id: "qa-sports-nfl",
                          ripple: false,
                          flat: "",
                          value: "favorites"
                        },
                        on: {
                          click: function() {
                            _vm.togglePmBetslipOff()
                            _vm.toggleHome()
                          }
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "btn-icon-container" },
                          [
                            _c("icon", {
                              attrs: { name: "icon-nfl", colorName: "blue" }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "bottom_nav_text" }, [
                          _vm._v(_vm._s(_vm.$t("BottomNav.Sports")))
                        ])
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.canHaveNavElm("BETSLIP")
                  ? _c(
                      "v-btn",
                      {
                        staticClass: "sports menu",
                        class: [
                          { active: _vm.pmShowBetSlip },
                          { "betslip-button": _vm.brandLayout === "generic" }
                        ],
                        attrs: {
                          id: "qa-sports-betslip-icon",
                          ripple: false,
                          flat: "",
                          color: "teal",
                          value: "recent"
                        },
                        on: {
                          click: function($event) {
                            return _vm.togglePmBetslip()
                          }
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "btn-icon-container" },
                          [
                            _c("v-icon", { staticClass: "betslip-icon" }, [
                              _vm._v("receipt")
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "bottom_nav_text" }, [
                          _vm._v(_vm._s(_vm.$t("BottomNav.Betslip")))
                        ]),
                        _vm._v(" "),
                        _vm.pmSelectedRunnersCount > 0
                          ? _c(
                              "badge",
                              {
                                class: {
                                  "ios-badge":
                                    _vm.userAgent !== "ios" &&
                                    _vm.iosAppVersion === "fromWeb"
                                }
                              },
                              [_vm._v(_vm._s(_vm.pmSelectedRunnersCount))]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.canHaveNavElm("MYBETS") && _vm.brandTemplate === "generic_2"
                  ? _c(
                      "v-btn",
                      {
                        staticClass: "betslip-button",
                        class: { active: _vm.isMyBetsActive },
                        attrs: {
                          id: "qa-sports-betslip-icon",
                          ripple: false,
                          flat: "",
                          value: "nearby"
                        },
                        on: {
                          click: function($event) {
                            return _vm.toggleMyBets()
                          }
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "btn-icon-container" },
                          [
                            _c("v-icon", { staticClass: "betslip-icon" }, [
                              _vm._v("receipt")
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "bottom_nav_text" }, [
                          _vm._v(_vm._s(_vm.$t("BottomNav.MyBets")))
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            : _vm.routerNavGroups &&
              _vm.routerNavGroups.navset === "mixed" &&
              _vm.hasActiveNavGroups(["pm"]) &&
              _vm.navgroupcontext4menu !== "pm"
            ? [
                _c(
                  "router-link",
                  { staticClass: "v-btn", attrs: { to: _vm.homeHandler() } },
                  [
                    _c(
                      "v-btn",
                      {
                        staticClass: "home promotions-v2",
                        class: { active: _vm.activeHome },
                        attrs: {
                          id: "qa-sports-home",
                          ripple: false,
                          flat: "",
                          value: "favorites"
                        },
                        on: {
                          click: function($event) {
                            return _vm.toggleHome()
                          }
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "btn-icon-container" },
                          [
                            _c("icon", {
                              attrs: {
                                name: "icon-home",
                                colorName: _vm.activeHome ? "blue" : "dark"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "bottom_nav_text",
                            class: _vm.activeHome ? "blue" : ""
                          },
                          [_vm._v(_vm._s(_vm.$t("BottomNav.SportsHome")))]
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    staticClass: "sports menu",
                    class: {
                      active: _vm.dialogSportsMenu || _vm.isSportsActive
                    },
                    attrs: {
                      id: "qa-sports-nfl",
                      ripple: false,
                      flat: "",
                      color: "teal",
                      value: "recent"
                    },
                    on: {
                      click: function($event) {
                        return _vm.toggleMenu()
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "btn-icon-container" },
                      [
                        _c("icon", {
                          attrs: { name: "icon-nfl", colorName: "blue" }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "bottom_nav_text",
                        class: _vm.dialogSportsMenu ? "blue" : ""
                      },
                      [_vm._v(_vm._s(_vm.$t("BottomNav.AllSports")))]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    staticClass: "sports menu",
                    class: { btnHR: _vm.brandLayout === "generic" },
                    attrs: {
                      id: "qa-sports-horseracing",
                      ripple: false,
                      flat: "",
                      color: "teal",
                      value: "recent"
                    },
                    on: {
                      click: function($event) {
                        return _vm.go2PmBetting()
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "btn-icon-container" }, [
                      _c("span", { staticClass: "icon-horseracing" })
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "bottom_nav_text" }, [
                      _vm._v(_vm._s(_vm.$t("BottomNav.Racing")))
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm.canHaveNavElm("BETSLIP")
                  ? _c(
                      "v-btn",
                      {
                        staticClass: "betslip-button",
                        class: {
                          active: _vm.dialogBetslip,
                          hasSelections: _vm.selectionsNo > 0
                        },
                        attrs: {
                          id: "qa-sports-betslip-icon",
                          ripple: false,
                          flat: "",
                          value: "nearby"
                        },
                        on: {
                          click: function($event) {
                            return _vm.toggleBetslip()
                          }
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "btn-icon-container" },
                          [
                            _c("v-icon", { staticClass: "betslip-icon" }, [
                              _vm._v("receipt")
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "bottom_nav_text" }, [
                          _vm._v(_vm._s(_vm.$t("BottomNav.Betslip")))
                        ]),
                        _vm._v(" "),
                        _vm.selectionsNo > 0
                          ? _c(
                              "badge",
                              {
                                class: {
                                  "ios-badge":
                                    _vm.userAgent !== "ios" &&
                                    _vm.iosAppVersion === "fromWeb"
                                }
                              },
                              [_vm._v(_vm._s(_vm.selectionsNo))]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.feedback,
                                expression: "feedback"
                              }
                            ],
                            staticClass: "betslip_mobile_msg",
                            class: {
                              ios_betslip_mobile_msg:
                                _vm.userAgent === "ios" &&
                                _vm.iosAppVersion === "fromWeb"
                            }
                          },
                          [_c("p", [_vm._v(_vm._s(_vm.feedback))])]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.canHaveNavElm("MYBETS") && _vm.brandTemplate === "generic_2"
                  ? _c(
                      "v-btn",
                      {
                        staticClass: "betslip-button",
                        class: { active: _vm.isMyBetsActive },
                        attrs: {
                          id: "qa-sports-betslip-icon",
                          ripple: false,
                          flat: "",
                          value: "nearby"
                        },
                        on: {
                          click: function($event) {
                            return _vm.toggleMyBets()
                          }
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "btn-icon-container" },
                          [
                            _c("v-icon", { staticClass: "betslip-icon" }, [
                              _vm._v("receipt")
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "bottom_nav_text" }, [
                          _vm._v(_vm._s(_vm.$t("BottomNav.MyBets")))
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            : _vm.routerNavGroups && _vm.routerNavGroups.navset === "pm"
            ? [
                _c(
                  "v-btn",
                  {
                    staticClass: "sports menu",
                    class: {
                      "home promotions-v2": _vm.brandLayout === "generic"
                    },
                    attrs: {
                      id: "qa-sports-home",
                      ripple: false,
                      flat: "",
                      color: "teal",
                      value: "recent"
                    },
                    on: {
                      click: function() {
                        _vm.togglePmBetslipOff()
                        _vm.go2PmBetting()
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "btn-icon-container" },
                      [_c("icon", { attrs: { name: "icon-home" } })],
                      1
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "bottom_nav_text" }, [
                      _vm._v(_vm._s(_vm.$t("BottomNav.Home")))
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    staticClass: "sports menu",
                    class: [
                      { active: _vm.dialogSportsMenu || _vm.isSportsActive },
                      { btnHR: _vm.brandLayout === "generic" }
                    ],
                    attrs: {
                      id: "qa-sports-horseracing",
                      ripple: false,
                      flat: "",
                      color: "teal",
                      value: "recent"
                    },
                    on: {
                      click: function() {
                        _vm.togglePmBetslipOff()
                        _vm.toggleMenu()
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "btn-icon-container" }, [
                      _c("span", { staticClass: "icon-horseracing" })
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "bottom_nav_text",
                        class: _vm.dialogSportsMenu ? "blue" : ""
                      },
                      [_vm._v(_vm._s(_vm.$t("BottomNav.AllRacing")))]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    staticClass: "sports menu",
                    class: [
                      { active: _vm.pmShowBetSlip },
                      { "betslip-button": _vm.brandLayout === "generic" }
                    ],
                    attrs: {
                      id: "qa-sports-betslip-icon",
                      ripple: false,
                      flat: "",
                      color: "teal",
                      value: "recent"
                    },
                    on: {
                      click: function($event) {
                        return _vm.togglePmBetslip()
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "btn-icon-container" },
                      [
                        _c("v-icon", { staticClass: "betslip-icon" }, [
                          _vm._v("receipt")
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "bottom_nav_text" }, [
                      _vm._v(_vm._s(_vm.$t("BottomNav.Betslip")))
                    ]),
                    _vm._v(" "),
                    _vm.pmSelectedRunnersCount > 0
                      ? _c(
                          "badge",
                          {
                            class: {
                              "ios-badge":
                                _vm.userAgent !== "ios" &&
                                _vm.iosAppVersion === "fromWeb"
                            }
                          },
                          [_vm._v(_vm._s(_vm.pmSelectedRunnersCount))]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ]
            : _vm.routerNavGroups &&
              _vm.routerNavGroups.navset === "mixed" &&
              _vm.navgroupcontext4menu === "racing"
            ? [
                _c(
                  "router-link",
                  { staticClass: "v-btn", attrs: { to: _vm.homeHandler() } },
                  [
                    _c(
                      "v-btn",
                      {
                        staticClass: "home promotions-v2",
                        attrs: {
                          id: "qa-sports-home",
                          ripple: false,
                          flat: "",
                          value: "favorites"
                        },
                        on: {
                          click: function($event) {
                            return _vm.toggleHome()
                          }
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "btn-icon-container" },
                          [
                            _c("icon", {
                              attrs: {
                                name: "icon-home",
                                colorName: _vm.activeHome ? "blue" : "dark"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "bottom_nav_text" }, [
                          _vm._v(_vm._s(_vm.$t("BottomNav.SportsHome")))
                        ])
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    staticClass: "btnracing",
                    attrs: {
                      id: "qa-racing-menu",
                      ripple: false,
                      flat: "",
                      color: "teal"
                    },
                    on: {
                      click: function() {
                        _vm.emitNavigationEvent("notifyRacingIframeToDo", {
                          action: "toggle-menu"
                        })
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "btn-icon-container" },
                      [
                        _c("v-icon", {
                          staticClass: "icon-racing icon-racingmenu"
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "bottom_nav_text" }, [
                      _vm._v(_vm._s(_vm.$t("BottomNav.RacingMenu")))
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    staticClass: "btnracing",
                    attrs: {
                      id: "qa-racing-home",
                      ripple: false,
                      flat: "",
                      color: "teal"
                    },
                    on: {
                      click: function() {
                        _vm.emitNavigationEvent("notifyRacingIframeToDo", {
                          action: "go-home"
                        })
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "btn-icon-container" }, [
                      _c("span", { staticClass: "icon-racing icon-racinghome" })
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "bottom_nav_text" }, [
                      _vm._v(_vm._s(_vm.$t("BottomNav.RacingHome")))
                    ])
                  ]
                )
              ]
            : [
                _vm.canHaveNavElm("HOME")
                  ? _c(
                      "router-link",
                      {
                        staticClass: "v-btn",
                        attrs: { to: _vm.homeHandler() }
                      },
                      [
                        _c(
                          "v-btn",
                          {
                            staticClass: "home promotions-v2",
                            class: { active: _vm.activeHome },
                            attrs: {
                              id: "qa-sports-home",
                              ripple: false,
                              flat: "",
                              value: "favorites"
                            },
                            on: {
                              click: function($event) {
                                return _vm.toggleHome()
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "btn-icon-container" },
                              [
                                _c("icon", {
                                  attrs: {
                                    name: "icon-home",
                                    colorName: _vm.activeHome ? "blue" : "dark"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass: "bottom_nav_text",
                                class: _vm.activeHome ? "blue" : ""
                              },
                              [_vm._v(_vm._s(_vm.$t("BottomNav.Home")))]
                            )
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.canHaveNavElm("SPORTS")
                  ? _c(
                      "v-btn",
                      {
                        staticClass: "sports menu",
                        class: {
                          active: _vm.dialogSportsMenu || _vm.isSportsActive
                        },
                        attrs: {
                          id: "qa-sports-nfl",
                          ripple: false,
                          flat: "",
                          color: "teal",
                          value: "recent"
                        },
                        on: {
                          click: function($event) {
                            return _vm.toggleMenu()
                          }
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "btn-icon-container" },
                          [
                            _c("icon", {
                              attrs: { name: "icon-nfl", colorName: "blue" }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "bottom_nav_text",
                            class: _vm.dialogSportsMenu ? "blue" : ""
                          },
                          [_vm._v(_vm._s(_vm.$t("BottomNav.AllSports")))]
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.canHaveNavElm("BETSLIP")
                  ? _c(
                      "v-btn",
                      {
                        staticClass: "betslip-button",
                        class: {
                          active: _vm.dialogBetslip,
                          hasSelections: _vm.selectionsNo > 0
                        },
                        attrs: {
                          id: "qa-sports-betslip-icon",
                          ripple: false,
                          flat: "",
                          value: "nearby"
                        },
                        on: {
                          click: function($event) {
                            return _vm.toggleBetslip()
                          }
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "btn-icon-container" },
                          [
                            _c("v-icon", { staticClass: "betslip-icon" }, [
                              _vm._v("receipt")
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "bottom_nav_text" }, [
                          _vm._v(_vm._s(_vm.$t("BottomNav.Betslip")))
                        ]),
                        _vm._v(" "),
                        _vm.selectionsNo > 0
                          ? _c(
                              "badge",
                              {
                                class: {
                                  "ios-badge":
                                    _vm.userAgent !== "ios" &&
                                    _vm.iosAppVersion === "fromWeb"
                                }
                              },
                              [_vm._v(_vm._s(_vm.selectionsNo))]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.feedback,
                                expression: "feedback"
                              }
                            ],
                            staticClass: "betslip_mobile_msg",
                            class: {
                              ios_betslip_mobile_msg:
                                _vm.userAgent === "ios" &&
                                _vm.iosAppVersion === "fromWeb"
                            }
                          },
                          [_c("p", [_vm._v(_vm._s(_vm.feedback))])]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.canHaveNavElm("MYBETS") && _vm.brandTemplate === "generic_2"
                  ? _c(
                      "v-btn",
                      {
                        staticClass: "betslip-button",
                        class: { active: _vm.isMyBetsActive },
                        attrs: {
                          id: "qa-sports-betslip-icon",
                          ripple: false,
                          flat: "",
                          value: "nearby"
                        },
                        on: {
                          click: function($event) {
                            return _vm.toggleMyBets()
                          }
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "btn-icon-container" },
                          [
                            _c("v-icon", { staticClass: "betslip-icon" }, [
                              _vm._v("receipt")
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "bottom_nav_text" }, [
                          _vm._v(_vm._s(_vm.$t("BottomNav.MyBets")))
                        ])
                      ]
                    )
                  : _vm._e()
              ],
          _vm._v(" "),
          _vm.navigationType
            ? _c(
                "v-btn",
                {
                  attrs: { id: "qa-sports-specialLink" },
                  on: {
                    click: function($event) {
                      return _vm.specialLink()
                    }
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "btn-icon-container" },
                    [
                      _c("icon", {
                        attrs: { name: _vm.navigationName, colorName: "dark" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "bottom_nav_text" }, [
                    _vm._v(_vm._s(_vm.$t("BottomNav.SpecialLink")))
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.canHaveNavElm("PROMOS")
            ? _c(
                "v-btn",
                {
                  staticClass: "promo",
                  class: { active: _vm.isPromotionsPageActive },
                  attrs: { id: "qa-sports-promos" },
                  on: {
                    click: function($event) {
                      return _vm.go2Promotions()
                    }
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "btn-icon-container" },
                    [_c("v-icon", [_vm._v("stars")])],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "bottom_nav_text" }, [
                    _vm._v(_vm._s(_vm.$t("BottomNav.Promos")))
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.canHaveNavElm("PLACED_BETS")
            ? _c(
                "v-btn",
                {
                  staticClass: "placed_bets",
                  class: { active: _vm.isPlacedBetsPageActive },
                  attrs: { id: "qa-sports-placed-bets" },
                  on: {
                    click: function($event) {
                      return _vm.go2PlacedBets()
                    }
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "btn-icon-container" },
                    [_c("v-icon", [_vm._v("attach_money")])],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "bottom_nav_text" }, [
                    _vm._v(_vm._s(_vm.$t("BottomNav.PlacedBets")))
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.canHaveNavElm("SAVED_BETS")
            ? _c(
                "v-btn",
                {
                  staticClass: "saved_bets",
                  class: { active: _vm.isSavedBetsPageActive },
                  attrs: { id: "qa-sports-saved-bets" },
                  on: {
                    click: function($event) {
                      return _vm.go2SavedBets()
                    }
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "btn-icon-container" },
                    [_c("v-icon", [_vm._v("save")])],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "bottom_nav_text" }, [
                    _vm._v(_vm._s(_vm.$t("BottomNav.SavedBets")))
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.canHaveNavElm("INFO")
            ? _c(
                "v-btn",
                {
                  staticClass: "info",
                  class: {
                    active: _vm.dialogHamburgerMenu || _vm.isInfoActive
                  },
                  attrs: { flat: "" },
                  on: {
                    click: function($event) {
                      return _vm.toggleHamburgerMenu()
                    }
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "btn-icon-container" },
                    [_c("icon", { attrs: { name: "icon-info" } })],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "bottom_nav_text" }, [
                    _vm._v(_vm._s(_vm.$t("BottomNav.Info")))
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.canHaveNavElm("CONTESTS")
            ? _c(
                "v-btn",
                {
                  staticClass: "contests",
                  class: { active: _vm.isContestsPageActive },
                  on: {
                    click: function($event) {
                      return _vm.go2Contests()
                    }
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "btn-icon-container" },
                    [_c("v-icon", [_vm._v("stars")])],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "bottom_nav_text" }, [
                    _vm._v(_vm._s(_vm.$t("BottomNav.Contests")))
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.canHaveNavElm("PROFILE")
            ? _c(
                "v-btn",
                {
                  staticClass: "account",
                  class: [
                    { active: _vm.dialogMyAccount || _vm.isMyProfileActive },
                    { withAlerts: _vm.noOfMsgs > 0 && _vm.isLoggedIn }
                  ],
                  attrs: {
                    id: "qa-sports-profile",
                    ripple: false,
                    flat: "",
                    value: "nearby"
                  },
                  on: {
                    click: function() {
                      if (_vm.isLoggedIn) {
                        _vm.toggleMyAccount()
                      } else {
                        _vm.toggleLogin()
                      }
                    }
                  }
                },
                [
                  _vm.brandTemplate !== "generic_2"
                    ? _c(
                        "div",
                        { staticClass: "btn-icon-container" },
                        [_c("v-icon", [_vm._v("account_circle")])],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.brandTemplate === "generic_2"
                    ? _c(
                        "div",
                        { staticClass: "btn-icon-container" },
                        [_c("v-icon", [_vm._v("account_circle")])],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "bottom_nav_text",
                      class: _vm.dialogMyAccount ? "blue" : ""
                    },
                    [_vm._v(_vm._s(_vm.$t("BottomNav.Profile")))]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.canHaveNavElm("MORE")
            ? _c(
                "v-btn",
                {
                  staticClass: "info",
                  class: {
                    active: _vm.dialogHamburgerMenu || _vm.isInfoActive
                  },
                  attrs: { flat: "" },
                  on: {
                    click: function($event) {
                      return _vm.toggleHamburgerMenu()
                    }
                  }
                },
                [
                  _c("div", { staticClass: "btn-icon-container more" }, [
                    _vm._v("...")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "bottom_nav_text" }, [
                    _vm._v(_vm._s(_vm.$t("BottomNav.More")))
                  ])
                ]
              )
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _vm.mobileBigAndBelow
        ? _c(
            "v-navigation-drawer",
            {
              staticClass: "dialog-menu dialogsportsmenu",
              attrs: {
                app: "",
                fixed: "",
                "disable-resize-watcher": "",
                "disable-route-watcher": ""
              },
              model: {
                value: _vm.dialogSportsMenu,
                callback: function($$v) {
                  _vm.dialogSportsMenu = $$v
                },
                expression: "dialogSportsMenu"
              }
            },
            [
              _vm.brandLayout !== "generic" && _vm.brandKey !== "sb"
                ? _c(
                    "div",
                    { staticClass: "header" },
                    [
                      _c(
                        "v-layout",
                        { staticClass: "title" },
                        [
                          _c(
                            "v-flex",
                            { staticClass: "logo-wrapper" },
                            [_c("logo", { attrs: { mode: "light" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { staticClass: "close" },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "close",
                                  attrs: { flat: "" },
                                  on: {
                                    click: function($event) {
                                      return _vm.toggleMenu()
                                    }
                                  }
                                },
                                [_c("v-icon", [_vm._v("close")])],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.brandKey === "sb" ||
              (_vm.brandLayout === "generic" &&
                _vm.brandTemplate !== "generic_2")
                ? _c(
                    "v-flex",
                    { staticClass: "close" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "close",
                          attrs: { flat: "" },
                          on: {
                            click: function($event) {
                              return _vm.toggleMenu()
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("close")])],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              (_vm.routerNavGroups.navset === "mixed" &&
                _vm.navgroupcontext4menu === "pm") ||
              _vm.routerNavGroups.navset === "pm"
                ? _c(
                    "div",
                    { staticClass: "sports-menu" },
                    [
                      _c("site-navigation", {
                        staticClass: "popular expand navigation topmenu",
                        attrs: { "navigation-section": "RACING_MENU_TOP" }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "wrapper sports-az all_racing navigation"
                        },
                        [
                          _c("h3", [_c("span", [_vm._v("All Racing")])]),
                          _vm._v(" "),
                          _c(
                            "ul",
                            { staticClass: "bo-navigation" },
                            _vm._l(_vm.pmMeetingsBreeds, function(
                              breed,
                              breedIx
                            ) {
                              return _c(
                                "li",
                                {
                                  key: breedIx,
                                  staticClass: "navigation-item"
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.pmNavToBreed(breed)
                                        }
                                      }
                                    },
                                    [
                                      _c("icon", {
                                        attrs: {
                                          name: "icon-" + breed.toLowerCase()
                                        }
                                      }),
                                      _vm._v(_vm._s(breed))
                                    ],
                                    1
                                  )
                                ]
                              )
                            }),
                            0
                          )
                        ]
                      )
                    ],
                    1
                  )
                : [
                    _vm.brandTemplate === "generic_2"
                      ? _c(
                          "div",
                          { staticClass: "sports_menu_header_holder" },
                          [
                            _c("div", { staticClass: "sports_menu_header" }, [
                              _c("h3", [
                                _vm._v(_vm._s(_vm.$t("Sports.SportAZ")))
                              ])
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("sports-menu")
                  ]
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.mobileBigAndBelow &&
      _vm.brandLayout === "generic" &&
      _vm.isInfoMenuEnabled
        ? _c(
            "v-navigation-drawer",
            {
              staticClass: "dialog-menu hamburger",
              attrs: {
                app: "",
                fixed: "",
                "disable-resize-watcher": "",
                "disable-route-watcher": ""
              },
              model: {
                value: _vm.dialogHamburgerMenu,
                callback: function($$v) {
                  _vm.dialogHamburgerMenu = $$v
                },
                expression: "dialogHamburgerMenu"
              }
            },
            [
              _vm.brandTemplate === "generic_2"
                ? _c("div", { staticClass: "sports_menu_header_holder" }, [
                    _c("div", { staticClass: "sports_menu_header" }, [
                      _c("h3", [_vm._v(_vm._s(_vm.$t("BottomNav.Info")))])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.brandTemplate !== "generic_2"
                ? _c(
                    "div",
                    { staticClass: "header" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "close",
                          attrs: { flat: "" },
                          on: {
                            click: function($event) {
                              return _vm.toggleHamburgerMenu()
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("close")])],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("hamburger-menu")
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.mobileBigAndBelow && !this.$route.name.includes("casino")
        ? _c(
            "v-dialog",
            {
              attrs: {
                "content-class": "dialog-betslip",
                fullscreen: "",
                persistent: "",
                "hide-overlay": "",
                transition: "dialog-bottom-transition"
              },
              model: {
                value: _vm.dialogBetslip,
                callback: function($$v) {
                  _vm.dialogBetslip = $$v
                },
                expression: "dialogBetslip"
              }
            },
            [_c("betslip")],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.mobileBigAndBelow && !this.$route.name.includes("casino")
        ? _c(
            "v-dialog",
            {
              attrs: {
                "content-class": "dialog-betslip pm",
                fullscreen: "",
                persistent: "",
                "hide-overlay": "",
                transition: "dialog-bottom-transition"
              },
              model: {
                value: _vm.dialogBetslipPM,
                callback: function($$v) {
                  _vm.dialogBetslipPM = $$v
                },
                expression: "dialogBetslipPM"
              }
            },
            [_c("betslip-pari-mutuel")],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0b557933", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b557933","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/parts/BottomNavigation.vue
// module id = null
// module chunks = 